<template>
  <b-container>
    <div class="transactions-page page w-100 p-0 m-0">
      <div class="page__header">
        <h2>My Transactions</h2>
      </div>
      <div class="page__card">
        <div class="page__card__content">
          <b-tabs v-model="tabIndex" nav-class="justify-content-center">
            <b-tab
              title="Current"
              title-link-class="nav-title"
              @click="setTab(0)"
            >
              <transaction-list :active="tabIndex === 0" status="pending" />
            </b-tab>
            <b-tab title="Past" title-link-class="nav-title" @click="setTab(1)">
              <transaction-list :active="tabIndex === 1" status="past" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * Transactions page
 * ==================================================================================
 **/

import TransactionList from '@/components/lists/TransactionList'

const HASH = ['#current', '#past']

export default {
  metaInfo: function() {
    return {
      title: 'Transactions'
    }
  },
  components: {
    TransactionList
  },
  data: function() {
    return {
      tabIndex: 0
    }
  },
  methods: {
    setTab(index) {
      this.$router.push({
        name: 'transaction.transactions-page',
        hash: HASH[index]
      })
    }
  },
  created() {
    this.tabIndex = HASH.indexOf(this.$route.hash)
  }
}
</script>
<style lang="scss" scoped>
.transactions-page /deep/ {
  .nav-tabs {
    margin-bottom: 25px;
  }

  .page__header {
    padding-bottom: 0;
  }

  .page__card {
    margin-top: 30px;

    &__content {
      width: 100%;
      padding-bottom: 0;
    }
  }
}
</style>
